import {
  GET_AGE_GATE_CONFIG_PENDING,
  GET_AGE_GATE_CONFIG_REJECTED,
  GET_AGE_GATE_CONFIG_FULFILLED,
} from "../../constants/ageGateConfig";

const ageGateConfig = (state = {}, action) => {
  switch (action.type) {
    case GET_AGE_GATE_CONFIG_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case GET_AGE_GATE_CONFIG_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case GET_AGE_GATE_CONFIG_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data,
      };
    default:
      return state;
  }
};

export default ageGateConfig;
